export const PRODIGIO_COMPANY_ID = 48;
export const PROENEM_BRAND_ID = 92;
